/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Navbar_logoUrl_logo_ishealth from "../assets/logo-ishealth.png";
import Navbar_extraIcons_0_iconUrl_icon_line_logo from "../assets/icon-line-logo.png";
import flagTh from "../assets/flag-th.png";
import flagEn from "../assets/flag-en.png";

interface NavbarSectionProps {
  lang?: "th" | "en";
  onNavigate?: (path: string) => void;
  onLangChange?: (lang: string) => void;
}

const NavbarSection: React.FC<NavbarSectionProps> = ({ lang = "th", onNavigate, onLangChange }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    if (onNavigate) {
      e.preventDefault();
      onNavigate(path);
    }
  };

  const navItems = [{"label":"หน้าหลัก","href":"#hero"},{"label":"ฟีเจอร์","href":"#features"},{"label":"ราคา","href":"#pricing"}];
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeHref, setActiveHref] = useState(navItems[0]?.href || "");
  const [selectedLang, setSelectedLang] = useState(lang === "en" ? "EN" : "TH");
  const [langOpen, setLangOpen] = useState(false);
  const langRef = useRef<HTMLDivElement>(null);
  const languages = ["TH","EN"];
  useEffect(() => { setSelectedLang(lang === "en" ? "EN" : "TH"); }, [lang]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [mobileOpen]);

  // Track active section on scroll
  useEffect(() => {
    const sectionIds = navItems.map((item) => item.href).filter((h) => h.startsWith("#")).map((h) => h.slice(1));
    const scrollParent = document.querySelector("[class$=\"-page\"]")?.parentElement;
    const handleScroll = () => {
      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const el = document.getElementById(sectionIds[i]);
        if (el && el.getBoundingClientRect().top <= 120) {
          setActiveHref("#" + sectionIds[i]);
          return;
        }
      }
      if (sectionIds.length > 0) setActiveHref("#" + sectionIds[0]);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    if (scrollParent) {
      scrollParent.addEventListener("scroll", handleScroll, { passive: true });
    }
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollParent) {
        scrollParent.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  // Close lang dropdown on outside click
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (langRef.current && !langRef.current.contains(e.target as Node)) setLangOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <nav style={{ position: "sticky", top: 0, zIndex: 1000, backgroundColor: "#ffffff", color: "#2C2C2B", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
      <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 24px", maxWidth: "95%", margin: "0 auto" }}>
        {/* Logo */}
        <a href="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}>
          <img src={Navbar_logoUrl_logo_ishealth} alt="IsHealth Cloud" style={{ height: "40px", width: "auto" }} />
          <span style={{ fontSize: "1.25rem", fontWeight: 700, marginLeft: "8px", fontFamily: "var(--font-family-en, var(--font-family))" }}>IsHealth Cloud</span>
        </a>

        {/* Center Nav Items */}
        <div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", display: "flex", alignItems: "center", gap: "8px" }} className="desktop-nav">
          {navItems.map((item, i) => {
            const label = typeof item.label === "object" ? (item.label as Record<string, string>)[lang] || (item.label as Record<string, string>).th : item.label;
            const labelFontFamily = /[฀-๿]/.test(String(label)) ? undefined : "var(--font-family-en, var(--font-family))";
            return (
            <a key={i} href={item.href} onClick={(e) => { e.preventDefault(); setActiveHref(item.href); const el = document.getElementById(item.href.slice(1)); if (el) el.scrollIntoView({ behavior: "smooth" }); }} style={{ position: "relative", padding: "8px 16px", fontSize: "17px",  color: "inherit", textDecoration: "none", fontWeight: activeHref === item.href ? 700 : 500, cursor: "pointer", ...(labelFontFamily ? { fontFamily: labelFontFamily } : {}) }}>
              {label}
              <span style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: "3px", background: "linear-gradient(90deg, #fda0b8, #f9c26f)", borderRadius: "2px", transform: activeHref === item.href ? "scaleX(1)" : "scaleX(0)", transformOrigin: "center", transition: "transform 0.3s ease" }} />
            </a>
            );
          })}
        </div>

        {/* Right Items */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }} className="desktop-nav">
          <div style={{ position: "relative", display: "inline-block" }} ref={langRef}>
            <button onClick={() => setLangOpen(!langOpen)} style={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", padding: "4px 8px", borderRadius: "4px", fontSize: "0.85rem", fontWeight: 500, color: "inherit", background: "none", border: "none", fontFamily: "inherit" }}>
              <img src={selectedLang === "TH" ? flagTh : flagEn} alt={selectedLang} style={{ width: "20px", height: "20px", borderRadius: "50%", objectFit: "cover" }} /> {selectedLang} ▾
            </button>
            {langOpen && (
              <div style={{ position: "absolute", top: "100%", left: 0, marginTop: "4px", backgroundColor: "#ffffff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", overflow: "hidden", zIndex: 1300, minWidth: "80px" }}>
                {languages.map((lang) => (
                  <div key={lang} onClick={() => { setSelectedLang(lang); setLangOpen(false); onLangChange?.(lang); }} style={{ padding: "8px 12px", fontSize: "0.85rem", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", backgroundColor: lang === selectedLang ? "#f3f4f6" : "transparent" }}>
                    <img src={lang === "TH" ? flagTh : flagEn} alt={lang} style={{ width: "18px", height: "18px", borderRadius: "50%", objectFit: "cover" }} /> {lang}
                  </div>
                ))}
              </div>
            )}
          </div>
          <a href="https://lin.ee/o0tMH9k" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}><img src={Navbar_extraIcons_0_iconUrl_icon_line_logo} alt="" style={{ height: "24px", width: "24px", objectFit: "contain" }} /></a>
          <a href="/download" onClick={(e) => handleClick(e, "/download")} style={{ padding: "8px 16px", background: "transparent", color: "#2C2C2B", border: "1px solid #2C2C2B", borderRadius: "8px", textDecoration: "none", fontWeight: 600, fontSize: "0.875rem", whiteSpace: "nowrap", fontFamily: "var(--font-family-en, var(--font-family))" }}>Download App</a>
          <a href="/login" onClick={(e) => handleClick(e, "/login")} style={{ marginLeft: "8px", padding: "10px 20px", background: "rgba(44, 44, 43, 1)", color: "#ffffff", borderRadius: "8px", textDecoration: "none", fontWeight: 600, fontSize: "0.875rem", whiteSpace: "nowrap" }}>เข้าสู่ระบบ →</a>
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMobileOpen(true)}
          className="mobile-menu-btn"
          style={{ display: "none", background: "none", border: "none", cursor: "pointer", padding: "8px", color: "inherit" }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 12h18M3 6h18M3 18h18" /></svg>
        </button>
      </div>

      {/* Mobile Drawer */}
      {mobileOpen && (
        <>
          <div onClick={() => setMobileOpen(false)} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9998 }} />
          <div style={{ position: "fixed", top: 0, right: 0, bottom: 0, width: "80%", maxWidth: "300px", backgroundColor: "#ffffff", zIndex: 9999, boxShadow: "-4px 0 20px rgba(0,0,0,0.15)", overflowY: "auto", display: "flex", flexDirection: "column" }}>
            <div style={{ padding: "16px" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
                <button onClick={() => setMobileOpen(false)} style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", background: "none", border: "none", cursor: "pointer", color: "inherit" }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><path d="M18 6L6 18M6 6l12 12" /></svg>
                </button>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {navItems.map((item, i) => {
                  const mLabel = typeof item.label === "object" ? (item.label as Record<string, string>)[lang] || (item.label as Record<string, string>).th : item.label;
                  const mFontFamily = /[฀-๿]/.test(String(mLabel)) ? undefined : "var(--font-family-en, var(--font-family))";
                  return (
                    <a key={i} href={item.href} onClick={(e) => { e.preventDefault(); setMobileOpen(false); setActiveHref(item.href); const el = document.getElementById(item.href.slice(1)); if (el) el.scrollIntoView({ behavior: "smooth" }); }} style={{ display: "block", paddingTop: "12px", paddingBottom: "12px", fontWeight: activeHref === item.href ? 700 : 500, color: "inherit", textDecoration: "none", borderBottom: activeHref === item.href ? "3px solid" : "1px solid #e5e7eb", borderImage: activeHref === item.href ? "linear-gradient(90deg, #fda0b8, #f9c26f) 1" : "none", ...(mFontFamily ? { fontFamily: mFontFamily } : {}) }}>
                      {mLabel}
                    </a>
                  );
                })}
                <a href="/download" onClick={(e) => { setMobileOpen(false); handleClick(e, "/download"); }} style={{ display: "block", padding: "8px 24px", color: "#2C2C2B", border: "1.5px solid #2C2C2B", backgroundColor: "transparent", borderRadius: "8px", fontWeight: 600, textAlign: "center", textDecoration: "none", fontFamily: "var(--font-family-en, var(--font-family))" }}>Download App</a>
                <a href="https://lin.ee/o0tMH9k" onClick={(e) => { setMobileOpen(false); handleClick(e, "https://lin.ee/o0tMH9k"); }} style={{ display: "block", padding: "8px 24px", backgroundColor: "#2C2C2B", color: "#ffffff", border: "none", borderRadius: "8px", fontWeight: 600, textAlign: "center", textDecoration: "none" }}>ติดต่อสอบถาม</a>

              </div>
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default NavbarSection;
